"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteAPIVersion = void 0;
var AuthSuiteAPIVersion;
(function (AuthSuiteAPIVersion) {
    AuthSuiteAPIVersion["DEFAULT"] = "2017-12-31";
    AuthSuiteAPIVersion["WITH_PROFILE_CHANGE_EVENTS"] = "2020-04-01";
    AuthSuiteAPIVersion["WITH_ON_HOLD_PAYMENT_STATUS"] = "2020-09-15";
    AuthSuiteAPIVersion["WITH_VALIDATION_ERROR_MESSAGES"] = "2021-01-07";
})(AuthSuiteAPIVersion = exports.AuthSuiteAPIVersion || (exports.AuthSuiteAPIVersion = {}));
